import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

// DyreID DPM (2026-10-08): see docs/superpowers/specs/2026-10-08-dyreid-dpm-integration-design.md
// Embeds DyreID's prescribing module. Drawers have no close hook, so the
// callback fires on unmount: button, backdrop and swipe all end here, once.

@observer
class DpmLauncher extends Component {
    componentWillUnmount() {
        const { callback } = this.props;
        if (!this.notified && typeof callback === 'function') {
            this.notified = true;
            callback();
        }
    }

    onClickClose = e => {
        e.preventDefault();
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { url } = this.props;
        return (
            <div class='w-100 h-100 d-flex flex-column pt-5'>
                <div class='d-flex justify-content-end px-3 pb-2'>
                    <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill' onClick={this.onClickClose}>
                        <i class='fa-solid fa-xmark me-2' /> <Text id='dyrejournal.prescription.dpmClose'>Close</Text>
                    </button>
                </div>
                <iframe class='w-100 flex-fill border-0' src={url} allowfullscreen title='DyreID e-resept' />
            </div>
        );
    }
}

export default DpmLauncher;
